import React, {useEffect, useRef} from "react";

import "./JackpotLeavelBlock.scss";
import Odometer from "odometer";

const JackpotLeavelBlock = () => {
  const odometerRef = useRef(null);

  let baseOdometer:any;
  let amount = 193845.81;

  useEffect(() => {
    baseOdometer = new Odometer({
      el: odometerRef.current,
      value: amount,   // initial value
      format: "(,ddd).dd",
      theme: "default",
    });
  }, [])

  function updateBaseAmount(newAmount: number) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    baseOdometer.update(newAmount);
  }

  useEffect(() => {
    const timer = setInterval(() => {
      updateBaseAmount(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          amount = amount + Math.floor(Math.random() * (55 - 15 + 1) + 15)
      )
    }, 5000);
    // clearing interval
    return () => clearInterval(timer);
  }, [])

  return (
    <div className="casinoJackpotLabelBlock-bc">
      <h3 className="casinoJackpotLabelTitle-bc">
        Pikes
        <span>
          <svg
            width="124px"
            height="21px"
            viewBox="0 0 124 21"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <title>Jackpot</title>
            <desc>Created with Sketch.</desc>
            <defs>
              <linearGradient
                x1="5.67132988e-13%"
                y1="49.9475539%"
                x2="99.7710904%"
                y2="49.9475539%"
                id="linearGradient-1"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="50%"
                y1="99.9358513%"
                x2="50%"
                y2="0%"
                id="linearGradient-2"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="0.197335964%"
                y1="50%"
                x2="99.802664%"
                y2="50%"
                id="linearGradient-3"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="50%"
                y1="100%"
                x2="50%"
                y2="0%"
                id="linearGradient-4"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="0.0785007198%"
                y1="49.9851666%"
                x2="99.9349046%"
                y2="49.9851666%"
                id="linearGradient-5"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="50.4961746%"
                y1="99.8911075%"
                x2="50.4961746%"
                y2="0.0829449317%"
                id="linearGradient-6"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="0%"
                y1="50%"
                x2="100%"
                y2="50%"
                id="linearGradient-7"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="50.2208202%"
                y1="100%"
                x2="50.2208202%"
                y2="4.13346559e-14%"
                id="linearGradient-8"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="0%"
                y1="50.0648709%"
                x2="99.9065829%"
                y2="50.0648709%"
                id="linearGradient-9"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="50.0223967%"
                y1="100%"
                x2="50.0223967%"
                y2="0%"
                id="linearGradient-10"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="0.0858036747%"
                y1="49.9640816%"
                x2="99.9157239%"
                y2="49.9640816%"
                id="linearGradient-11"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="49.970768%"
                y1="100.001031%"
                x2="49.970768%"
                y2="0.0773346587%"
                id="linearGradient-12"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="0%"
                y1="50%"
                x2="100%"
                y2="50%"
                id="linearGradient-13"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="50%"
                y1="100%"
                x2="50%"
                y2="0%"
                id="linearGradient-14"
              >
                <stop stopColor="#FCCB00" offset="1%" />
                <stop stopColor="#FFFAD1" offset="25%" />
                <stop stopColor="#FAF1C0" offset="30%" />
                <stop stopColor="#EDD993" offset="39%" />
                <stop stopColor="#D8B34B" offset="51%" />
                <stop stopColor="#C99716" offset="60%" />
                <stop stopColor="#E9CC72" offset="81%" />
                <stop stopColor="#F2DC8D" offset="87%" />
                <stop stopColor="#FFFAD1" offset="100%" />
              </linearGradient>
            </defs>
            <g
              id="Jackpot"
              stroke="none"
              strokeWidth={1}
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="Front---Jackpot"
                transform="translate(-125.000000, -139.000000)"
                fillRule="nonzero"
              >
                <g id="Jackpot" transform="translate(125.000000, 139.000000)">
                  <g id="Group-8" transform="translate(0.000000, 0.025979)">
                    <path
                      d="M3.85869565,19.998 C3.26210083,19.9982233 2.66629539,19.9541047 2.07608696,19.866 C1.50291429,19.7816626 0.936302725,19.6566884 0.380434783,19.492 L0,19.382 L0,14.19 L0.739130435,14.487 C0.969054612,14.5719259 1.20531267,14.6381363 1.44565217,14.685 C1.67391802,14.737175 1.90729075,14.7630065 2.14130435,14.762 C2.88648858,14.8483456 3.62709003,14.5657515 4.13043478,14.003 C4.64299671,13.0804823 4.85950819,12.0195304 4.75,10.967 L4.75,-3.55271368e-15 L10.8695652,-3.55271368e-15 L10.8695652,12.166 C11.0287679,14.2692144 10.4217393,16.3586608 9.16304348,18.04 C7.75857444,19.4392879 5.82357554,20.1535563 3.85869565,19.998 L3.85869565,19.998 Z"
                      id="Path"
                      fill="url(#linearGradient-1)"
                    />
                    <path
                      d="M5.29347826,0.352 L10.326087,0.352 L10.326087,11.99 C10.326087,14.487 9.80434783,16.39 8.75,17.49 C7.45497508,18.7784134 5.66805069,19.4294257 3.85869565,19.272 C2.73609397,19.2768655 1.61894738,19.1137694 0.543478261,18.788 L0.543478261,14.751 C0.801680111,14.8597566 1.07166354,14.9372929 1.34782609,14.982 C1.60869928,15.0384028 1.87455214,15.067887 2.14130435,15.07 C3.05870751,15.1633596 3.96343215,14.7979482 4.56521739,14.091 C5.13557305,13.0921906 5.3897398,11.9404738 5.29347826,10.791 L5.29347826,0.352 Z"
                      id="Path"
                      fill="url(#linearGradient-2)"
                    />
                  </g>
                  <g id="Group-7" transform="translate(10.869565, 0.025979)">
                    <path
                      d="M15.4347826,19.998 L14.1304348,15.994 L7.60869565,15.994 L6.19565217,19.998 L0,19.998 L7.60869565,3.55271368e-15 L14.423913,3.55271368e-15 L22.0326087,19.998 L15.4347826,19.998 Z M12.5326087,11.308 L10.8695652,6.49 L9.20652174,11.341 L12.5326087,11.308 Z"
                      id="Shape"
                      fill="url(#linearGradient-3)"
                    />
                    <path
                      d="M7.98913043,0.583 L14.0652174,0.583 L21.2065217,19.492 L15.826087,19.492 L14.4891304,15.477 L7.2173913,15.477 L5.81521739,19.492 L0.836956522,19.492 L7.98913043,0.583 Z M10.923913,4.796 L8.47826087,11.891 L13.2934783,11.891 L10.923913,4.796 Z"
                      id="Shape"
                      fill="url(#linearGradient-4)"
                    />
                  </g>
                  <g id="Group-6" transform="translate(32.334718, 0.011814)">
                    <path
                      d="M10.937021,20.0121651 C8.0297227,20.1854433 5.16603942,19.2338456 2.92615144,17.3501651 C0.931968563,15.4232825 -0.13191041,12.711582 0.0131079643,9.92516513 C-0.106156833,7.20667306 0.939818706,4.56837409 2.88267318,2.68716513 C5.01264492,0.827569305 7.76885506,-0.129769923 10.5783254,0.0141651251 C11.5949545,0.0103981144 12.6098756,0.098750813 13.6109341,0.278165125 C14.5308702,0.435253747 15.4311244,0.693448125 16.2957167,1.04816513 L16.6544123,1.20216513 L16.1000645,6.17416513 L15.4044123,5.75616513 C14.7903048,5.38345617 14.1282444,5.09842636 13.437021,4.90916513 C12.7571992,4.71950597 12.0552455,4.62330907 11.3500645,4.62316513 C9.90124971,4.54102592 8.48145721,5.0570146 7.41528188,6.05316513 C5.50695842,8.25655677 5.50695842,11.5497735 7.41528188,13.7531651 C8.50456092,14.7470567 9.93980949,15.2615562 11.4044123,15.1831651 C12.0997107,15.1829165 12.7926725,15.1017159 13.4696297,14.9411651 C14.2173325,14.7666377 14.9456763,14.5160291 15.6435427,14.1931651 L16.3283254,13.8741651 L16.6978906,19.1101651 L16.2957167,19.2311651 C15.420464,19.468822 14.5309213,19.6488654 13.6326732,19.7701651 C12.7405037,19.9119328 11.8399185,19.9927822 10.937021,20.0121651 Z"
                      id="Path"
                      fill="url(#linearGradient-5)"
                    />
                    <path
                      d="M16.1218036,1.47716513 L15.6978906,5.27216513 C15.0389183,4.87293873 14.3295802,4.56581729 13.5891949,4.35916513 C12.8634092,4.15604173 12.1139611,4.05244973 11.3609341,4.05116513 C9.7593467,3.96049158 8.19008283,4.53220579 7.01310796,5.63516513 C4.84521936,8.05759444 4.84521936,11.7487358 7.01310796,14.1711651 C8.1971913,15.2622363 9.76135692,15.8320931 11.3609341,15.7551651 C12.093192,15.7520528 12.8226512,15.6634673 13.5348471,15.4911651 C14.3108211,15.3149147 15.0653379,15.0530136 15.7848471,14.7101651 L16.0783254,18.7801651 C15.2253476,19.0187554 14.3574345,19.198831 13.4804993,19.3191651 C12.6125599,19.4420102 11.7373193,19.50449 10.8609341,19.5061651 C8.06995597,19.6787624 5.31863059,18.770312 3.16528188,16.9651651 C1.27014408,15.1282649 0.265167064,12.543464 0.415281877,9.89216513 C0.291234818,7.30982938 1.28304244,4.8005561 3.13267318,3.01716513 C5.1721343,1.23770842 7.81346745,0.326986103 10.5022384,0.476165125 C11.4895214,0.473721132 12.4751358,0.558374867 13.4478906,0.729165125 C14.3640907,0.876241462 15.2610346,1.1271524 16.1218036,1.47716513 L16.1218036,1.47716513 Z"
                      id="Path"
                      fill="url(#linearGradient-6)"
                    />
                  </g>
                  <g id="Group-5" transform="translate(51.217391, 0.025979)">
                    <polygon
                      id="Path"
                      fill="url(#linearGradient-7)"
                      points="11.2282609 19.998 6.11956522 12.463 6.11956522 19.998 0 19.998 0 3.55271368e-15 6.11956522 3.55271368e-15 6.11956522 7.018 11.1413043 3.55271368e-15 18.1847826 3.55271368e-15 10.8043478 9.251 18.8586957 19.998"
                    />
                    <polygon
                      id="Path"
                      fill="url(#linearGradient-8)"
                      points="0.543478261 0.583 5.57608696 0.583 5.57608696 8.745 11.423913 0.583 17.0543478 0.583 10.1195652 9.273 17.7282609 19.492 11.4673913 19.492 5.5326087 10.692 5.5326087 19.492 0.5 19.492"
                    />
                  </g>
                  <g id="Group-4" transform="translate(71.445652, 0.000000)">
                    <path
                      d="M2.84217094e-14,20.0239795 L2.84217094e-14,0.0259794686 L7.2826087,0.0259794686 C9.45869684,-0.130735022 11.6269326,0.424577206 13.4673913,1.60997947 C14.9304002,2.82500357 15.7204853,4.68245705 15.5869565,6.59297947 C15.7031287,8.52391677 14.9427774,10.4030569 13.5217391,11.6969795 C11.8484291,12.9467004 9.79280136,13.5583228 7.7173913,13.4239795 L6.11956522,13.4239795 L6.11956522,20.0239795 L2.84217094e-14,20.0239795 Z M6.90217391,8.92497947 C7.58462406,8.98059901 8.26490494,8.79390226 8.82608696,8.39697947 C9.24339559,7.9963791 9.45917387,7.42619697 9.41304348,6.84597947 C9.46742561,6.20361963 9.25017756,5.56803873 8.81521739,5.09697947 C8.27550616,4.67789249 7.60234815,4.47430474 6.92391304,4.52497947 L6.11956522,4.52497947 L6.11956522,8.92497947 L6.90217391,8.92497947 Z"
                      id="Shape"
                      fill="url(#linearGradient-9)"
                    />
                    <path
                      d="M0.543478261,0.608979469 L7.2826087,0.608979469 C9.92391304,0.608979469 11.8695652,1.09297947 13.1413043,2.07197947 C14.4650036,3.18993233 15.1735041,4.88615535 15.0434783,6.62597947 C15.1601653,8.39719845 14.4669789,10.1246029 13.1630435,11.3119795 C11.5957847,12.4801942 9.67043868,13.0491417 7.72826087,12.9179795 L5.55434783,12.9179795 L5.55434783,19.5179795 L0.52173913,19.5179795 L0.543478261,0.608979469 Z M5.57608696,4.00797947 L5.57608696,9.50797947 L6.90217391,9.50797947 C7.71627487,9.56855223 8.52518606,9.33466134 9.18478261,8.84797947 C9.7218982,8.34274514 10.0053959,7.61943467 9.95652174,6.87897947 C10.0113994,6.08559092 9.73088658,5.30592322 9.18478261,4.73397947 C8.54793536,4.21334301 7.74087118,3.95418228 6.92391304,4.00797947 L5.57608696,4.00797947 Z"
                      id="Shape"
                      fill="url(#linearGradient-10)"
                    />
                  </g>
                  <g id="Group-3" transform="translate(88.440219, 0.026223)">
                    <path
                      d="M9.51630245,19.9977569 C6.923949,20.1420779 4.3912208,19.1759171 2.53804158,17.3357569 C0.771729277,15.3238352 -0.135008365,12.685682 0.0163024459,9.99875691 C-0.128518497,7.31607391 0.777567515,4.68376907 2.53804158,2.67275691 C6.51555339,-0.89091897 12.4953124,-0.89091897 16.4728242,2.67275691 C18.2252558,4.68790997 19.1267678,7.31826428 18.9836938,9.99875691 C19.1332032,12.6834846 18.2310514,15.3196581 16.4728242,17.3357569 C14.627821,19.1748044 12.1020865,20.1413083 9.51630245,19.9977569 Z M9.51630245,4.59775691 C8.47849731,4.57763691 7.50415309,5.10185877 6.94021549,5.98375691 C6.17124711,7.17381941 5.79103729,8.57823843 5.85325897,9.99875691 C5.78057844,11.416246 6.14112953,12.8219854 6.88586766,14.0247569 C7.45364113,14.9094045 8.43057056,15.4369628 9.47282419,15.4217569 C10.5083157,15.4444693 11.4805815,14.9191492 12.0380416,14.0357569 C12.7753036,12.8260964 13.1316467,11.4181469 13.0597807,9.99875691 C13.1314989,8.5882951 12.7708494,7.18985571 12.027172,5.99475691 C11.4960559,5.10390208 10.5443986,4.55774143 9.51630245,4.55375691 L9.51630245,4.59775691 Z"
                      id="Shape"
                      fill="url(#linearGradient-11)"
                    />
                    <path
                      d="M9.51630245,0.40675691 C11.9774475,0.262355225 14.38349,1.18194547 16.1358677,2.93675691 C17.8095647,4.86877752 18.6646667,7.38978991 18.5163024,9.95475691 C18.6682281,12.5202162 17.8126741,15.0425613 16.1358677,16.9727569 C12.3384431,20.3311609 6.67242268,20.3311609 2.8749981,16.9727569 C1.19008324,15.0467416 0.329943307,12.522403 0.48369375,9.95475691 C0.333545607,7.38761017 1.19322402,4.86462596 2.8749981,2.93675691 C4.63856691,1.18559104 7.04943431,0.267172877 9.51630245,0.40675691 Z M9.51630245,3.94875691 C8.30176763,3.92798568 7.1613616,4.53824238 6.49456332,5.56575691 C5.69480519,6.86049232 5.31478014,8.37575861 5.40760679,9.89975691 C5.30832557,11.4451865 5.68832492,12.9834238 6.49456332,14.2997569 C7.17431606,15.3131504 8.30600515,15.9199313 9.51630245,15.9199313 C10.7265997,15.9199313 11.8582888,15.3131504 12.5380416,14.2997569 C13.3436052,12.9831353 13.7235498,11.4451197 13.6249981,9.89975691 C13.7112097,8.37986439 13.3316017,6.87010262 12.5380416,5.57675691 C11.8826463,4.5353222 10.7359782,3.91754034 9.51630245,3.94875691 Z"
                      id="Shape"
                      fill="url(#linearGradient-12)"
                    />
                  </g>
                  <g id="Group-2" transform="translate(108.239130, 0.025979)">
                    <polygon
                      id="Path"
                      fill="url(#linearGradient-13)"
                      points="4.67391304 19.998 4.67391304 4.873 0 4.873 0 3.55271368e-15 15.4673913 3.55271368e-15 15.4673913 4.873 10.7934783 4.873 10.7934783 19.998"
                    />
                    <polygon
                      id="Path"
                      fill="url(#linearGradient-14)"
                      points="0.543478261 0.572 14.923913 0.572 14.923913 4.345 10.2391304 4.345 10.2391304 19.47 5.20652174 19.47 5.20652174 4.345 0.532608696 4.345"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </h3>
      <div ref={odometerRef} id="odometer" className="odometer casinoJackpotPrice-bc odometer-auto-theme" data-cur="₺"></div>
    </div>
  );
};

export { JackpotLeavelBlock };
